
const RESET_PASSWORD = 'RESET_PASSWORD';
export default RESET_PASSWORD;